export const OPEN_STRING_MIDI: Record<number, number> = {
  1: 64, 2: 59, 3: 55, 4: 50, 5: 45, 6: 40,
};

// ギターのフレット上限 (演奏可能域は 0..MAX_FRET)。FretScroller の表示範囲もこれに従う。
export const MAX_FRET = 24;

const NOTE_NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'] as const;

export function midiToNoteName(midi: number): string {
  return `${NOTE_NAMES[midi % 12]}${Math.floor(midi / 12) - 1}`;
}

// 弦とフレットから MIDI ノート番号を求める (弦→MIDI 変換の単一の出所)。
export function getMidiForStringFret(string: number, fret: number): number {
  return OPEN_STRING_MIDI[string] + fret;
}

export function getNoteFromStringFret(string: number, fret: number): string {
  return midiToNoteName(getMidiForStringFret(string, fret));
}

// midi と弦から、その弦で同じ音を出すフレットを求める (0..MAX_FRET 範囲外は null)。
// 音名文字列パースは含まない純算術 (#117 round2: 同じ音を他弦で探す用)。
export function getFretForNoteOnString(noteMidi: number, string: number): number | null {
  const f = noteMidi - OPEN_STRING_MIDI[string];
  return f >= 0 && f <= MAX_FRET ? f : null;
}
